import { Navigate, Outlet, useLocation } from "react-router-dom";

import { useSelector } from "react-redux";
import { selectAuth } from "state/auth/authSlice";

function ProtectedRoute() {
  const location = useLocation();
  const auth = useSelector(selectAuth);

  if (!(auth.user && auth.accessToken)) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Page chrome (sidebar/topbar/content paddings) is provided by the ShellV2
  // Layout in App.js; the legacy Soft UI DashboardLayout added sidenav
  // margins for a sidenav that no longer exists.
  return <Outlet />;
}

export default ProtectedRoute;
